/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Label_ManufacturedInputs */

const vi_product_lot_detail_label_manufactured = /** @type {(inputs: Product_Lot_Detail_Label_ManufacturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày sản xuất`)
};

/**

* @param {Product_Lot_Detail_Label_ManufacturedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_label_manufactured = /** @type {((inputs?: Product_Lot_Detail_Label_ManufacturedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Label_ManufacturedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_label_manufactured(inputs)
});